export default __webpack_public_path__ + "static/media/banner1.8ba1eac1.png";